<ion-header *ngIf="!p.renderMobile">
  <ion-item class="first-run__desktop-container">
    <ion-buttons slot="end" class="ion-no-margin">
      <app-user-settings></app-user-settings>
    </ion-buttons>
  </ion-item>
</ion-header>

<!-- MOBILE -->
<ion-content *ngIf="p.renderMobile" class="background-white">
  <swiper
    class="first-run__slider"
    [ngClass]="{'first-run__slider--disable-bullets': index == 0}"
    *ngIf="!hideSlider"
    #swiper
    [pagination]="{ clickable: true }"
    (progress)="progress($event)"
  >
    <ng-template class="first-run__slide-container" swiperSlide>
      <div class="first-run__pictures">
        <ion-img
          class="first-run__logo"
          src="assets/images/app-logo.svg"
        ></ion-img>
        <ion-img
          class="buildings"
          src="https://virtualreceptionfiles.blob.core.windows.net/assets/first-run/first-run-buildings.png"
        ></ion-img>
        <div class="ion-text-center">
          <h1 class="first-run__title">MyBuilding</h1>
          <p class="first-run__subtitle">{{"FIRST_RUN.INTRO" | translate}}</p>
        </div>
      </div>
      <div
        class="first-run__button-container first-run__button-container--with-logo"
      >
        <ion-button class="first-run__button" (click)="nextSlideMobile()">
          {{"NEXT" | translate}}
        </ion-button>
        <img
          class="first-run__sti-logo"
          src="../../../assets/images/sti-logo.png"
          alt=""
        />
      </div>
    </ng-template>

    <ng-template
      class="first-run__slide-container"
      swiperSlide
      *ngFor="let slide of slides, index as i "
    >
      <div class="first-run__slide-container">
        <div class="first-run__pictures">
          <ion-img
            class="first-run__image"
            [src]="slide.imageMobile"
            [ngClass]="{'first-run__circle-background': slide.mobileCircleBackground}"
          ></ion-img>
          <div class="ion-text-center">
            <h1 class="first-run__title">{{slide.header}}</h1>
            <p class="first-run__subtitle">{{slide.text}}</p>
          </div>
        </div>
        <div class="display-flex ion-justify-content-center">
          <ion-button 
            class="first-run__button"
            (click)="backSlideMobile()"
            fill="outline"
          >
            {{"FIRST_RUN.BACK" | translate}}
          </ion-button>
          <ion-button class="first-run__button" (click)="nextSlideMobile()">
            {{"NEXT" | translate}}
          </ion-button>
        </div>
      </div>
    </ng-template>
  </swiper>
  <app-first-run-push
    *ngIf="showPushAcceptance && hideSlider"
    (firstRunPush)="firstRunPush($event)"
  ></app-first-run-push>
</ion-content>

<!-- DESKTOP -->
<ion-content *ngIf="!p.renderMobile" class="background-white">
  <div>
    <ion-grid>
      <ion-row>
        <ion-col size="5">
          <div class="first-run__tile">
            <h3 class="first-run__desktop-title">{{slides[index].header}}</h3>

            <p class="first-run__desktop-description">{{slides[index].text}}</p>
            <ion-button 
              *ngIf="index > 0"
              (click)="backSlidePC()"
              fill="outline"
            >
              {{"FIRST_RUN.BACK" | translate}}
            </ion-button>
            <ion-button (click)="nextSlidePc()"
              >{{"NEXT" | translate}}</ion-button
            >
            <ion-button (click)="redirectToHome()" fill="clear"
              >{{"SKIP" |translate}}</ion-button
            >
          </div>
        </ion-col>
        <ion-col size="7">
          <img
            class="first-run__desktop-image"
            [src]="slides[index].imageDesktop"
          />
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
